.CRHeader
    width: 100%
    display: flex
    flex-direction: row
    align-items: center
    justify-content: space-between
    gap: 10px
    padding: 0 20px 10px
    .CRReserved
        display: flex
        flex-direction: row
        align-items: center
        justify-content: space-between
        gap: 10px
        .CRReservedInfo
            display: flex
            flex-direction: column
    .CRHeaderButton
        width: 36px
        height: 36px

.CRContent
    width: 100%
    display: flex
    flex-direction: column
    overflow-x: hidden
    overflow-y: auto
    .CRItemRow
        display: flex
        flex-direction: row
        align-items: center
        justify-content: space-between
        gap: 10px
        padding: 0 20px
        .CRItemRowPrice
            font-weight: 700
        .CRItemRowMileageTotalAmount
            font-size: .75rem

.CRSummaryContainer
    display: flex
    flex-direction: column
    margin-top: auto
    padding: 10px 20px 0
    border-top: 1px solid rgb($globalSettingsStrokeTertiary)
    .CRButtonContainer
        width: 100%
